import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { faCheckCircle, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Niveau, Objectif, Progression } from 'app/shared/models/Progression/progression';

@Component({
  selector: 'app-my-skills-table',
  templateUrl: './my-skills-table.component.html',
  styleUrls: ['./my-skills-table.component.scss']
})
export class MySkillsTableComponent implements OnInit {

  @Input() progression: Progression;
  @Input() baseUrl: string;

  faCheckCircle = faCheckCircle;
  faChevronLeft = faChevronLeft;


  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  isValid(objectif: Objectif): boolean {
    objectif?.sousObjectifs?.forEach(item => {
      if (item) {

      }
    })
    // return objectif.validation ? true : false;
    return false;
  }

  getLinear(color1: string, color2: string): SafeStyle {
    const color = this.sanitizer.bypassSecurityTrustStyle(`linear-gradient(${color1},${color2})`);
    return color;
  }

  getImg(levels: Niveau[]): string {

    let levelConfirm: Niveau = null;

    levels.forEach(item => {
      if (item.validation.dateValidation) { levelConfirm = item; }
    });
    // const i = index < 6 ? index : 3;
    return levelConfirm ? `${this.baseUrl}${levelConfirm?.niveauId}` : null;
  }
  checkIsValid(level: Niveau[]): boolean {
    let isValid = true;
    for (const o of level) {
      if (o.validation === null || o.validation.dateValidation === null) {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  getLevelString(level: string) {
    const levelSplit = level.split(' ');

    return levelSplit.length > 2 ?
      parseInt(levelSplit[1], 10) ?
        `${levelSplit[2]}` :
        `${levelSplit[1]} ${levelSplit[2]}`
      : levelSplit[1];
  }


}
